<ngx-spinner type="ball-triangle-path"></ngx-spinner>
<router-outlet></router-outlet>
<app-agent-chat *ngIf="authService.token$ | async"></app-agent-chat>